export const pdpa = {
    terms_title: 'Terms & Conditions',
    privacy_title: 'Privacy policy',
}
